import { c as _c } from "react/compiler-runtime";
import { HeroImage } from '../../GiftDetailHeader/_components/HeroImage';
interface MobileHeroProps {
  heroImageUrlList: string[];
  adultYN: boolean;
  imageAlt: string;
  thumbnailSrc?: string;
}
export const MobileHero = t0 => {
  const $ = _c(5);
  const {
    heroImageUrlList,
    adultYN,
    imageAlt,
    thumbnailSrc
  } = t0;
  let t1;
  if ($[0] !== adultYN || $[1] !== heroImageUrlList || $[2] !== imageAlt || $[3] !== thumbnailSrc) {
    t1 = <div className="hidden mobile:block tablet:block"><HeroImage heroImageUrlList={heroImageUrlList} adultYN={adultYN} imageAlt={imageAlt} thumbnailSrc={thumbnailSrc} /></div>;
    $[0] = adultYN;
    $[1] = heroImageUrlList;
    $[2] = imageAlt;
    $[3] = thumbnailSrc;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};